import type { FC } from 'react'
import { useState } from 'react'
import { ScoreIndicator } from './ScoreIndicator'

interface DashItem {
  text?: string
  thesis?: string
  date?: string
  score?: number
  avg?: number
  trend?: 'up' | 'down' | 'stable'
}

interface Props {
  label: string
  value: number
  color: string
  sub?: string
  items?: DashItem[]
}

export const DashCard: FC<Props> = ({ label, value, color, sub, items }) => {
  const [open, setOpen] = useState(false)

  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: '16px 20px',
        flex: '1 1 160px',
        minWidth: 160,
        cursor: items ? 'pointer' : 'default',
      }}
      onClick={() => items && setOpen((v) => !v)}
    >
      <div style={{ fontSize: 28, fontWeight: 700, color }}>{value}</div>
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          color: '#374151',
          marginTop: 2,
        }}
      >
        {label}
      </div>
      {sub && (
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
          {sub}
        </div>
      )}
      {items && (
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>
          {open ? '▾ hide' : '▸ show details'}
        </div>
      )}
      {open && items && (
        <div
          style={{
            marginTop: 8,
            borderTop: '1px solid #f3f4f6',
            paddingTop: 8,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {items.map((it, i) => (
            <div
              key={i}
              style={{
                fontSize: 12,
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              {it.score !== undefined && (
                <ScoreIndicator score={it.score} size={10} />
              )}
              {it.avg !== undefined && (
                <ScoreIndicator score={it.avg} size={10} />
              )}
              <span style={{ flex: 1 }}>{it.text ?? it.thesis}</span>
              {it.date && (
                <span style={{ color: '#9ca3af', fontSize: 11 }}>
                  {it.date}
                </span>
              )}
              {it.trend && (
                <span
                  style={{
                    fontSize: 11,
                    color: it.trend === 'up' ? '#10b981' : '#ef4444',
                  }}
                >
                  {it.trend === 'up' ? '↑' : '↓'}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
